import { Snackbar } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom'
import { InPageNavBar } from '../components/NavBar'
import SnackbarNotification from '../components/SnackbarNotification'

const WebPage = ({children}) => {
  return (
    <>
      <InPageNavBar/>
      <Outlet/>
      <SnackbarNotification/>
    </>
  )
}

export default WebPage
